import { useMemo } from 'react';
import { stitchPpis } from 'utils/ui2pStitchPPI';
import stichPpsi from 'utils/ui2pStitchPPSI';
import _ from 'lodash';

const getPublishedData = (ppsiEnrichmentData, ppsiId) => {
  const dish = ppsiEnrichmentData.referencedIFoodData;
  return { ...ppsiEnrichmentData, ppsiId, dish };
};

const getExcludedItemCodes = ppiDetails =>
  ppiDetails.filter(i => i.ppiNotRequired === true).map(i => i.itemCode) || [];

const getUsedPpis = (ppiDataIds, ppis) =>
  ppis
    .filter(
      ppi =>
        ppi.publishedPPIEnrichmentData &&
        ppiDataIds.includes(ppi.publishedPPIEnrichmentData.id)
    )
    .map(ppi => ppi.publishedPPIEnrichmentData);

const getPpsiWithIncludedPpis = (stitchedPpsi, excludedItemCodes) => {
  const ppiWithoutExcludeData =
    stitchedPpsi.ppiDetails.filter(
      i => !excludedItemCodes.includes(i.itemCode)
    ) || [];

  return {
    ...stitchedPpsi,
    ppiDetails: ppiWithoutExcludeData,
    updateNotificationList: []
  };
};

const usePpsisWithPpisNir = (ppsis, ppis, marketLanguage) => {
  const ppsisWithPpis = useMemo(() => {
    if (ppsis.length === 0 || ppis.length === 0) {
      return [];
    }

    return ppsis
      .filter(ppsi => ppsi.publishedPpsiEnrichmentData)
      .map(({ id, publishedPpsiEnrichmentData }) => {
        const publishedData = getPublishedData(publishedPpsiEnrichmentData, id);
        publishedData.info[marketLanguage].presentationName = _.unescape(
          publishedData.info[marketLanguage].presentationName
        );

        const ppiDataIds = publishedPpsiEnrichmentData.ppiDetails.map(
          a => a.ppiEnrichmentDataId
        );

        const usedPpis = getUsedPpis(ppiDataIds, ppis);

        const stitchedPpsi = stichPpsi(
          publishedData,
          stitchPpis(usedPpis),
          publishedPpsiEnrichmentData.referencedIFoodData
            .referencedIngredientEntities,
          marketLanguage
        );

        const excludedItemCodes = getExcludedItemCodes(
          publishedPpsiEnrichmentData.ppiDetails
        );
        return getPpsiWithIncludedPpis(stitchedPpsi, excludedItemCodes);
      });
  }, [marketLanguage, ppsis, ppis]);

  return ppsisWithPpis;
};

export default usePpsisWithPpisNir;
